var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMapBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#1F2647"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7716 12.9422V17.1775C27.772 17.3169 27.7312 17.4532 27.6543 17.5694C27.5773 17.6856 27.4677 17.7764 27.3392 17.8304C27.2522 17.865 27.1594 17.883 27.0657 17.8834C26.8783 17.8826 26.6983 17.81 26.5628 17.6804L24.9481 16.0569L22.6275 18.3863C22.4926 18.5168 22.3122 18.5897 22.1245 18.5897C21.9369 18.5897 21.7565 18.5168 21.6216 18.3863C21.489 18.2525 21.4147 18.0718 21.4147 17.8834C21.4147 17.695 21.489 17.5143 21.6216 17.3804L23.951 15.0599L22.3275 13.4452C22.2317 13.3431 22.1668 13.216 22.1403 13.0786C22.1137 12.9412 22.1266 12.7991 22.1775 12.6687C22.2315 12.5402 22.3223 12.4306 22.4385 12.3537C22.5547 12.2767 22.6911 12.2359 22.8304 12.2363H27.0657C27.2529 12.2363 27.4325 12.3107 27.5649 12.4431C27.6972 12.5755 27.7716 12.755 27.7716 12.9422ZM17.3863 21.6157L15.0657 23.9452L13.451 22.3216C13.349 22.2259 13.2219 22.161 13.0845 22.1344C12.947 22.1079 12.8049 22.1208 12.6745 22.1716C12.5461 22.2256 12.4365 22.3164 12.3595 22.4326C12.2826 22.5488 12.2418 22.6852 12.2422 22.8246V27.0599C12.2422 27.2471 12.3166 27.4266 12.4489 27.559C12.5813 27.6914 12.7609 27.7657 12.9481 27.7657H17.1834C17.3227 27.7662 17.4591 27.7254 17.5753 27.6484C17.6915 27.5715 17.7823 27.4619 17.8363 27.3334C17.8872 27.203 17.9001 27.0609 17.8735 26.9235C17.847 26.7861 17.7821 26.659 17.6863 26.5569L16.0628 24.9422L18.3922 22.6216C18.5048 22.4845 18.5623 22.3104 18.5536 22.1331C18.5449 21.9559 18.4706 21.7883 18.3451 21.6628C18.2196 21.5374 18.052 21.4631 17.8748 21.4544C17.6976 21.4457 17.5235 21.5032 17.3863 21.6157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMapBtn);
export default __webpack_public_path__ + "static/media/expand-map-btn.bfb3bf8f0b27508e2f99d284c537fa4a.svg";
export { ForwardRef as ReactComponent };